<template>
    <div>
        <v-row>
            <v-col :key="campaign.id" cols="12" class="colRetro">
                <v-menu offset-y left v-if="(campaign && ['DRAFT', 'PROVIDER_REFUSAL'].includes(campaign.status)) && $func.hasRight('import/add')">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn small depressed class=" btnImportCamp bg-gradient mb-4" v-bind="attrs" v-on="on">
                            <v-icon small color="white" class="mr-3">$plus_l</v-icon>
                            {{$t('addlist')}}
                        </v-btn>
                    </template>
                    <v-list style="z-index:100000">
                        <v-list-item link dense @click="displayUpload = true">
                            <v-list-item-title>{{$t('importfile')}}</v-list-item-title>
                        </v-list-item>
                        <v-list-item link dense @click="addList($event, campaign)">
                            <v-list-item-title>{{$t('addLexxyList')}}</v-list-item-title>
                        </v-list-item>
                        <v-list-item link dense v-if="$func.hasRight('contact/rent') && (campaign.type === 'CAMP_OUT_P' || campaign.sousType === 'campSMSconversational')" @click="openLib">
                            <v-list-item-title>{{$t('rentContacts')}}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <retroplanningContactListComponent :sousType="sousType" :loader="loading" :limitRetro="campaign" :retroplanning="campaign" @addList="addList($event, campaign)" @removeListFromLP="removeListFromLP($event, campaign)" @refreshData="$emit('refreshContactList')" :fromPresta="fromPresta" />
            </v-col>
        </v-row>

        <addListDialogComponent :loader="loading" :displayAddList="displayAddList" :retroplanning="campaign" :excludedIds="listIdToExclude" :entities="entities" @addToList="addToList" @close="closeAddListDialog" />
        <importContactComponent @closeModal="closeModal" :displayUpload="displayUpload" :returnData="true" />
        <LibraryDialogComponent v-if="formLib" :form="formLib" libType="SEGMENT" @cancel="formLib = null;" :libParams="{ 'source': 'PROFILIA', 'retroplanning_id': campaign.id, 'entity_id': campaign.entity_id.id }" @selectModel="selectModel" :showLibraryDialog="showLibraryDialog" @hideLibraryDialog="showLibraryDialog = false;" />
    </div>
</template>

<script>
import GenericDataService from '@/services/GenericDataService'
import FormDialogComponent from '@/components/dialogs/FormDialogComponent'
import getForm from "@/mixins/mixins";
import Loader from '@/components/Loader'
import dateManipulation from '@/mixins/dateManipulation'
import retroplanningContactListComponent from '@/modules/operations/operationsComponents/retroplanningContactListComponent'
import importContactComponent from '@/components/importContactComponent'
import addListDialogComponent from '@/modules/operations/operationsComponents/addListDialogComponent'
import LibraryDialogComponent from '../../../components/dialogs/LibraryDialogComponent.vue';

export default {
    name: "contactListComponent",
    components: { FormDialogComponent, Loader, retroplanningContactListComponent, importContactComponent, addListDialogComponent, LibraryDialogComponent },
    mixins: [getForm, dateManipulation],
    props:['loadData', 'limitRetroId', 'sousType', 'fromPresta'],
    data() {
        return {
            loading: false,
            entities : [],
            displayUpload: false,
            displayAddList: false,
            listIdToExclude:[],
            formLib: null,
            showLibraryDialog: false,
        }
    },
    computed: {
        campaign(){
            return !this.fromPresta ? this.$store.state.campaign.campaign : this.$store.state.missions.mission;
        }
    },
    watch: {
        loadData: {
            immediate: true,
            handler(val) {
                if(val) {
                    this.loading = true
                    GenericDataService.getData('/entity/getSelectList2').then((response) => {
                        this.entities = response.data.data;
                        this.loading = false;
                    });
                }
            }
        }
    },
    methods: {
        closeModal(reload = false) {
            if(reload) {
                this.addToList([reload], this.campaign);
            }
            this.displayUpload = false;
        },
        addToList($event, retroplanning) {
            this.displayAddList = false;
            this.loading = true;

            let newRetroplanning = this._.cloneDeep(retroplanning);
            if(newRetroplanning.config.hasOwnProperty('contact_list')) {
                $event.forEach(id => {
                    newRetroplanning.config.contact_list.push(id);
                });
            } else {
                newRetroplanning.config.contact_list = $event;
            }

            GenericDataService.postData('/retroplanning/' + newRetroplanning.id + '/setConfigRetroPlanning', { campaign : newRetroplanning }).then((response) => {
                this.$emit('refreshContactList');
                this.listIdToExclude = [];
                this.loading = false;
            })
        },
        removeListFromLP(listId, retro) {
            this.loading = true;

            let newRetroplanning = this._.cloneDeep(retro);
            newRetroplanning.config.contact_list.splice(newRetroplanning.config.contact_list.findIndex((e) => e == listId), 1);

            GenericDataService.postData('/retroplanning/' + newRetroplanning.id + '/setConfigRetroPlanning', { campaign : newRetroplanning }).then((response) => {
                this.$emit('refreshContactList');
                this.loading = false;
            });   
        },
        addList(contactlist, retro) {
            this.listIdToExclude = retro.config.hasOwnProperty('contact_list') ? retro.config.contact_list : []
            this.displayAddList = true
        },
        closeAddListDialog(){
            this.listIdToExclude = []
            this.displayAddList = false
        },
        openLib() {
            let url = '/library/getFilters?libType=SEGMENT&params[source]=PROFILIA';

            GenericDataService.getData(url).then((response) => {
                this.formLib = response.data.data;
                this.showLibraryDialog = true
            });
        },
        selectModel(model) {
            this.addToList([model.id], this.campaign);
        },
    },
}
</script>

<style lang="scss">
.colRetro {
    position:relative;
}
.btnImportCamp{
    position:absolute;
    z-index:5;
    top:28px;
    right:34px;
}
</style>